export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-20.e509936a.png";